import { useNarrow } from './use-narrow';
import { useActiveConversation } from '../components/chat/ActiveConversationContext';

/**
 * onClick for in-app navigation links.
 *
 * The chat is a companion overlay that RIDES ALONG: an open chat stays open across
 * a navigation, still on the same thread, still streaming. The only adjustment is
 * geometric — a fullscreen chat floats down to the side dock so the page just
 * navigated to is actually visible (#12548822344), and on narrow (where every open
 * size is full-screen, and the nav drawer opens *over* the chat) it collapses to the
 * bubble for the same reason.
 *
 * Not destructive: the chat surface stays mounted behind the bubble (see
 * FloatingChat), so an in-flight turn keeps thinking and a not-yet-persisted
 * thread isn't traded for a fresh one.
 */
export function useLeaveChatOnNavigate(): () => void {
  const narrow = useNarrow();
  const { minimizeChat, floatChatIfMaximized } = useActiveConversation();
  return () => {
    if (narrow) minimizeChat();
    else floatChatIfMaximized();
  };
}
